import { tanstackQueryService } from '@core/services/TanstackQuery.service';
import { abcloudzFlowChatService } from '../services/AbcloudzFlowChat.service';
import type {
  TAbortAnswerGenerationRequest,
  TCreateSessionRequest,
  TGetSessionsRequest,
  TSessionItem
} from '../models/flowChat.model';
import type { TResponseError } from 'AbcloudzFlowChat/models/abcloudzFlowChat.model';
import type { AxiosError } from 'axios';

class AbcloudzFlowChatMutation {
  public getSessionsWithAutoCreate$ = tanstackQueryService.mutation<
    { data: TSessionItem[] },
    AxiosError<TResponseError>,
    TGetSessionsRequest & { silent?: boolean }
  >({
    mutationFn: async (params) => {
      const response = await abcloudzFlowChatService.getSessions(params);
      const sessions = response.data.sessions;

      if (sessions.length > 0) {
        return { data: sessions };
      }

      const createRes = await abcloudzFlowChatService.createSession({
        flowId: params.flowId,
        silent: params.silent
      });

      return {
        data: [
          {
            id: createRes.data.session.id,
            name: createRes.data.session.name,
            flowId: params.flowId,
            createdAt: new Date().toISOString(),
            greeting: '',
            updatedAt: ''
          }
        ]
      };
    }
  });

  public createSession$ = tanstackQueryService.mutation({
    mutationFn: (payload: TCreateSessionRequest) => abcloudzFlowChatService.createSession(payload)
  });

  public abortSession$ = tanstackQueryService.mutation({
    mutationFn: ({ flowId, sessionId }: TAbortAnswerGenerationRequest) =>
      abcloudzFlowChatService.abortAnswerGeneration({ flowId, sessionId })
  });
}

const abcloudzFlowChatMutation = new AbcloudzFlowChatMutation();

export { abcloudzFlowChatMutation };
